// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__sD_dP","buttons":"PendingPaymentAlert_buttons__3PNY_"};